export const HOMEPAGE_DEMO_EXTRACT_HEADER = 'X-S-Shot-Demo-Extract';
export const HOMEPAGE_DEMO_EXTRACT_HEADER_VALUE = 'homepage';

export const HOMEPAGE_DEMO_EXTRACT_URL =
  'https://www.ozon.ru/product/aerogril-boma-10-v-1-aerogril-elektricheskiy-8-l-1800-vt-12-programm-2241802245/';

export const HOMEPAGE_DEMO_EXTRACT_PROMPT = 'технические характеристики';

function normalizePrompt(value: unknown): string {
  return typeof value === 'string' ? value.trim().replace(/\s+/g, ' ').toLocaleLowerCase('ru-RU') : '';
}

function normalizeUrl(value: unknown): string {
  if (typeof value !== 'string') {
    return '';
  }
  try {
    const parsed = new URL(value.trim());
    parsed.hash = '';
    return parsed.toString();
  } catch {
    return '';
  }
}

export function isHomepageDemoExtractInput(input: { prompt?: unknown; url?: unknown }) {
  return (
    normalizeUrl(input.url) === normalizeUrl(HOMEPAGE_DEMO_EXTRACT_URL) &&
    normalizePrompt(input.prompt) === normalizePrompt(HOMEPAGE_DEMO_EXTRACT_PROMPT)
  );
}
